
import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/RedboxAdvertising.css';

const RedboxAdvertising = () => {
  return (
    <>
      <Helmet>
        <title>Advertising | Redbox Global</title>
        <meta
          name="description"
          content="Advertising insights, brand strategy, digital marketing trends, media innovation, and global campaign analysis from Redbox Global."
        />
        <meta
          name="keywords"
          content="advertising strategy, digital marketing, global campaigns, brand leadership, media innovation, Redbox Advertising"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/advertising" />
        <meta property="og:title" content="Advertising | Redbox Global" />
        <meta
          property="og:description"
          content="Expert insights on advertising, brand strategy, and global media innovation."
        />
        <meta
          property="og:image"
          content="https://images.unsplash.com/photo-1492724441997-5dc865305da7?w=1200&h=630&fit=crop"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Advertising | Redbox Global" />
        <meta
          name="twitter:description"
          content="Global advertising and media strategy insights from Redbox Global."
        />
        <meta
          name="twitter:image"
          content="https://images.unsplash.com/photo-1492724441997-5dc865305da7?w=1200&h=630&fit=crop"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/advertising" />
      </Helmet>

      <div className="page-container">
        <div className="page-header">
          <h1>Advertising</h1>
          <p className="page-subtitle">
            Brand strategy, media innovation, and global marketing leadership
          </p>
        </div>

        <div className="page-content">

          {/* Featured Article */}
          <a
            href="/article/global-brand-strategy-2026"
            style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
          >
            <div className="featured-article">
              <div className="featured-image">
                <img
                  src="https://images.unsplash.com/photo-1492724441997-5dc865305da7?w=1200&h=600&fit=crop"
                  alt="Global advertising strategy"
                />
              </div>
              <div className="featured-content">
                {/* <span className="article-category">Featured Campaign</span> */}
                <h2>The Evolution of Global Brand Strategy in 2026</h2>
                <p>
                  How leading brands are redefining storytelling, audience engagement,
                  and digital media integration in an AI-driven world.
                </p>
                <span className="article-meta">February 11, 2026</span>
              </div>
            </div>
          </a>

          {/* Article Grid */}
          <div className="content-grid">

            <a
              href="/article/programmatic-advertising-growth"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=600&h=400&fit=crop"
                    alt="Digital advertising analytics"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Digital Media</span> */}
                  <h2>Programmatic Advertising and the Rise of AI Optimization</h2>
                  <p>
                    Data-driven targeting and automation are transforming global
                    campaign performance and ROI measurement.
                  </p>
                  <span className="article-meta">February 8, 2026</span>
                </div>
              </article>
            </a>

            <a
              href="/article/influencer-marketing-global-trends"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?w=600&h=400&fit=crop"
                    alt="Influencer marketing campaign"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Influencer Strategy</span> */}
                  <h2>Influencer Marketing in a Globalized Digital Landscape</h2>
                  <p>
                    Strategic partnerships and authenticity are redefining
                    consumer trust and brand positioning.
                  </p>
                  <span className="article-meta">February 6, 2026</span>
                </div>
              </article>
            </a>

            <a
              href="/article/sustainable-brand-communication"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=600&h=400&fit=crop"
                    alt="Sustainable brand campaign"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Brand Sustainability</span> */}
                  <h2>Communicating Sustainability Without Greenwashing</h2>
                  <p>
                    How brands can authentically integrate ESG messaging into
                    their global advertising campaigns.
                  </p>
                  <span className="article-meta">February 3, 2026</span>
                </div>
              </article>
            </a>

          </div>

        </div>
      </div>
    </>
  );
};

export default RedboxAdvertising;
